import { render, staticRenderFns } from "./smsMarketing.vue?vue&type=template&id=96fc6aa2&scoped=true&"
import script from "./smsMarketing.vue?vue&type=script&setup=true&lang=js&"
export * from "./smsMarketing.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./smsMarketing.vue?vue&type=style&index=0&id=96fc6aa2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fc6aa2",
  null
  
)

export default component.exports